module.exports = __webpack_public_path__ + "static/media/broker.b66aac80.png";